import type { IntakeData } from "./types";

/**
 * Fields whose string values are edited as prose. {@link String.trim} must not run on
 * every `updateIntake` keystroke — otherwise a trailing space is removed immediately and
 * the user cannot type word spacing normally.
 */
export function intakeStringPreserveWhitespaceWhileTyping(
  key: keyof IntakeData,
): boolean {
  if (key === "email") return false;
  const id = String(key);
  return (
    id.endsWith("Other") ||
    id.endsWith("Notes") ||
    id === "firstName" ||
    id === "lastName" ||
    id === "vascularSymptoms" ||
    id === "preExistingConditions" ||
    id === "currentMedications" ||
    id === "allergies" ||
    id === "majorSurgeries" ||
    id === "dentalDiscomfort" ||
    id === "otherCondition" ||
    id === "otherSpecialtyAdditionalInfo"
  );
}
